import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/common/Header';
import HomePage from './pages/HomePage';
import BookingPage from './pages/BookingPage';
import BookingSuccess from './pages/BookingSuccess';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminAppointmentDetail from './pages/AdminAppointmentDetail';
import AdminServices from './pages/AdminServices';
import AdminSmsSettings from './pages/AdminSmsSettings';
import AdminAmiSettings from './pages/AdminAmiSettings';
import AdminUsers from './pages/AdminUsers';
import AdminMonitoring from './pages/AdminMonitoring';
import AdminAuthMonitoring from './pages/AdminAuthMonitoring';
import AdminTodayAppointments from './pages/AdminTodayAppointments';
import AdminProfile from './pages/AdminProfile';
import AdminCallCenterReports from './pages/AdminCallCenterReports';
import AdminHisHub from './pages/AdminHisHub';
import AdminHisReports from './pages/AdminHisReports';
import AdminHisVoids from './pages/AdminHisVoids';
import AdminHisOnlineConversion from './pages/AdminHisOnlineConversion';
import AdminReports from './pages/AdminReports';
import AdminCustomerClub from './pages/AdminCustomerClub';
import AdminCustomerClubBuilder from './pages/AdminCustomerClubBuilder';
import AdminCustomerClubWatchdog from './pages/AdminCustomerClubWatchdog';
import AdminCustomerClubCash from './pages/AdminCustomerClubCash';
import AppointmentSearch from './pages/AppointmentSearch';
import PublicAppointmentSearch from './pages/PublicAppointmentSearch';
import PublicFileUpload from './pages/PublicFileUpload';
import PublicComplaintForm from './pages/PublicComplaintForm';
import AdminComplaints from './pages/AdminComplaints';
import AdminComplaintDetail from './pages/AdminComplaintDetail';
import AdminLayout from './components/admin/AdminLayout';
import UmamiAnalytics from './components/common/UmamiAnalytics';

function App() {
  return (
    <Router>
      <UmamiAnalytics />
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/search" element={<PublicAppointmentSearch />} />
          <Route path="/upload/:token" element={<PublicFileUpload />} />
          <Route path="/complaints" element={<PublicComplaintForm />} />

          {/* Admin Routes with Layout */}
          <Route path="/admin/login" element={<AdminLogin />} />

          <Route path="/admin/dashboard" element={
            <AdminLayout><AdminDashboard /></AdminLayout>
          } />
          <Route path="/admin/reports" element={
            <AdminLayout><AdminReports /></AdminLayout>
          } />
          <Route path="/admin/customer-club" element={
            <AdminLayout><AdminCustomerClub /></AdminLayout>
          } />
          <Route path="/admin/customer-club/builder" element={
            <AdminLayout><AdminCustomerClubBuilder /></AdminLayout>
          } />
          <Route path="/admin/customer-club/watchdog" element={
            <AdminLayout><AdminCustomerClubWatchdog /></AdminLayout>
          } />
          <Route path="/admin/customer-club/cash" element={
            <AdminLayout><AdminCustomerClubCash /></AdminLayout>
          } />
          <Route path="/admin/call-reports" element={
            <AdminLayout><AdminCallCenterReports /></AdminLayout>
          } />
          <Route path="/admin/his" element={
            <AdminLayout><AdminHisHub /></AdminLayout>
          } />
          <Route path="/admin/his/reports" element={
            <AdminLayout><AdminHisReports /></AdminLayout>
          } />
          <Route path="/admin/his/online-conversion" element={
            <AdminLayout><AdminHisOnlineConversion /></AdminLayout>
          } />
          <Route path="/admin/his/voids" element={
            <AdminLayout><AdminHisVoids /></AdminLayout>
          } />
          <Route path="/admin/his-reports" element={<Navigate to="/admin/his/reports" replace />} />
          <Route path="/admin/appointments/:id" element={
            <AdminLayout><AdminAppointmentDetail /></AdminLayout>
          } />
          <Route path="/admin/services" element={
            <AdminLayout><AdminServices /></AdminLayout>
          } />
          <Route path="/admin/users" element={
            <AdminLayout><AdminUsers /></AdminLayout>
          } />
          <Route path="/admin/monitoring" element={
            <AdminLayout><AdminMonitoring /></AdminLayout>
          } />
          <Route path="/admin/admin-monitoring" element={
            <AdminLayout><AdminAuthMonitoring /></AdminLayout>
          } />
          <Route path="/admin/today-appointments" element={
            <AdminLayout><AdminTodayAppointments /></AdminLayout>
          } />
          <Route path="/admin/profile" element={
            <AdminLayout><AdminProfile /></AdminLayout>
          } />
          <Route path="/admin/search" element={
            <AdminLayout><AppointmentSearch /></AdminLayout>
          } />
          <Route path="/admin/settings/sms" element={
            <AdminLayout><AdminSmsSettings /></AdminLayout>
          } />
          <Route path="/admin/ami" element={
            <AdminLayout><AdminAmiSettings /></AdminLayout>
          } />
          <Route path="/admin/settings/ami" element={
            <AdminLayout><AdminAmiSettings /></AdminLayout>
          } />
          <Route path="/admin/complaints" element={
            <AdminLayout><AdminComplaints /></AdminLayout>
          } />
          <Route path="/admin/complaints/:id" element={
            <AdminLayout><AdminComplaintDetail /></AdminLayout>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
